import React from 'react';
import { AvGroup } from 'availity-reactstrap-validation';
import { FormattedMessage, useIntl } from 'react-intl';
import { Label } from 'reactstrap';
import {
  capitalize,
  getItemDataOrAdditionPrice,
  getLocaleHierarchy,
  getLocalizedCategoryName,
  getLocalizedName,
  trimText,
  anyConfigRequiresAdditionMapping,
} from '../../../../utility/util/util.service';
import Select, { createFilter } from 'react-select';
import { connect } from 'react-redux';

const AdditionsField = ({
  object,
  setter,
  options,
  isDisabled,
  store,
  checkout,
  ...props
}) => {
  const intl = useIntl();
  const stringifyLocalized = (option) =>
    getLocaleHierarchy(intl.locale).reduce(
      (searchString, locale) =>
        searchString + (option.data['name' + locale] || '') + ';',
      '',
    );

  const filteredOptions = options?.filter((addition) => {
    const hasPosIntegration = anyConfigRequiresAdditionMapping(store);
    const hasPosIntegrationRef =
      addition?.posIntegrationRef !== undefined &&
      addition?.posIntegrationRef !== null;

    // If store has posIntegration and the addition has a valid posIntegrationRef, keep it.
    return !hasPosIntegration || hasPosIntegrationRef;
  });

  return (
    <AvGroup
      data-testid="additionsField"
      className="react-select form-label-group"
    >
      <Select
        id={object?.id}
        isMulti={true}
        isDisabled={isDisabled}
        delimiter=";"
        name="additions"
        noOptionsMessage={() =>
          intl.formatMessage({ id: 'noAdditionsAvailableToSelect' })
        }
        className={'react-select-container'}
        classNamePrefix={'react-select'}
        value={object?.additions}
        getOptionLabel={(addition) => {
          const name = getLocalizedName(addition, intl.locale);
          const price = intl.formatNumber(
            getItemDataOrAdditionPrice(checkout?.orderType, addition),
            { format: 'priceCurrency' },
          );
          const category = getLocalizedCategoryName(addition, intl.locale);

          return `${
            category ? capitalize(category) + ' |' : ''
          } ${name} (${price})`;
        }}
        getOptionValue={(addition) => addition.id}
        onChange={(values) =>
          setter({
            ...object,
            additions: values || [],
            additionIds: values?.map((addition) => addition.id) || [],
          })
        }
        filterOption={createFilter({ stringify: stringifyLocalized })}
        placeholder={intl.formatMessage({ id: 'selectAdditionsLabel' })}
        options={filteredOptions}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({ ...base, zIndex: 9999 }),
        }}
        {...props}
      />
      <Label className="floating-label" for={object?.id}>
        <FormattedMessage id="additionsTitle" />
      </Label>
    </AvGroup>
  );
};

const mapStateToProps = (state) => ({
  checkout: state.store.checkout,
});

export default connect(mapStateToProps, {})(AdditionsField);
